const shouldReturnToOpener = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('return_to_opener')
}

// For authorization consultant coming from b2c - we need to have window.opener === b2c
export const openOauthInSameTabIfNeeded = (oauthPath) => {
  if (!shouldReturnToOpener()) return

  window.location.href = oauthPath
}

export const generateSuccessLoginResponse = (response) => {
  if (shouldReturnToOpener()) return { code: response.code, returnToOpener: true, mpcCode: response.mpc_code }

  return response
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/helpers.js